declare namespace $ {

	export class $bog_vmap_app_palette_item extends $mol_button_minor {
		current( ): boolean
		minimal_height( ): number
		drag_start( next?: any ): any
		lacking( ): boolean
		attr( ): ({ 
			'bog_vmap_app_palette_item_current': ReturnType< $bog_vmap_app_palette_item['current'] >,
			'bog_vmap_app_palette_item_lacking': ReturnType< $bog_vmap_app_palette_item['lacking'] >,
		})  & ReturnType< $mol_button_minor['attr'] >
		event( ): ({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_palette_item['drag_start'] > ): ReturnType< $bog_vmap_app_palette_item['drag_start'] >,
		})  & ReturnType< $mol_button_minor['event'] >
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map